import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { ActionReducerMap, StoreModule } from "@ngrx/store";
import { AuthTelemetryEffect } from "@obg/ngx.ui.common";

import { emailLoginReducer } from "./email-login/email-login.reducer";
import { LoginEffect } from "./login/login.effect";
import { sgaLoginReducer } from "./sga-login/sga-login.reducer";
import { LoginFeatureState } from "./state";
import { SuspiciousLoginEffect } from "./suspicious-login/suspicious-login.effect";
import { suspiciousLoginReducer } from "./suspicious-login/suspicious-login.reducer";
import { ResetPasswordEffect } from "./telemetry/reset-password/reset-password.effect";

export const LOGIN_FEATURE_REDUCER: ActionReducerMap<LoginFeatureState["loginFeature"]> = {
	suspiciousLogin: suspiciousLoginReducer,
	sgaLogin: sgaLoginReducer,
	emailLogin: emailLoginReducer,
};

const LOGIN_EFFECTS = [LoginEffect, ResetPasswordEffect, AuthTelemetryEffect, SuspiciousLoginEffect];
@NgModule({
	imports: [EffectsModule.forFeature(LOGIN_EFFECTS), StoreModule.forFeature("loginFeature", LOGIN_FEATURE_REDUCER)],
})
export class CommonLoginSdkModule {}
